import { Component, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header class="header-layout" fixed *ngIf="showHeader">
        <ngx-header></ngx-header>
      </nb-layout-header>

      <!-- <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar> -->

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed *ngIf="showFooter">
        <ngx-footer></ngx-footer>
      </nb-layout-footer>
    </nb-layout>
  `,
  encapsulation: ViewEncapsulation.None
})
export class OneColumnLayoutComponent {
  showFooter = true;
  showHeader = true;
  hiddenRoutes = ['/LINA', '/ai-assistance'];
  isInTeams = window.parent !== window.self;
  
  constructor(private router: Router) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.showFooter = !this.hiddenRoutes.includes(event.urlAfterRedirects);
      }
    });
  }
}
